import { Link } from 'react-router-dom'
import { ChevronRight, Leaf, ShieldCheck, Plug, BatteryCharging } from 'lucide-react'
import type { HeroSlide as HeroSlideType } from '../../model/types'

const ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  'leaf': Leaf,
  'shield-check': ShieldCheck,
  'plug': Plug,
  'battery-charging': BatteryCharging,
}

export function HeroSlide({ slide }: { slide: HeroSlideType }) {
  return (
    <div className="relative w-full h-full flex items-center bg-gradient-to-br from-brand-50 via-white to-brand-100 overflow-hidden">
      <img
        src={slide.image}
        alt={slide.title}
        className="absolute right-0 top-0 h-full w-[55%] object-contain opacity-80"
        onError={(e) => { (e.target as HTMLImageElement).style.display = 'none' }}
      />
      <div className="absolute right-0 top-0 h-full w-[55%] bg-gradient-to-l from-transparent via-transparent to-brand-50" />

      <div className="relative z-10 px-12 lg:px-16 max-w-2xl">
        <h1 className="text-4xl lg:text-5xl font-bold text-brand-700 leading-tight">
          {slide.title}
          <br />
          <span className="text-brand-600">{slide.subtitle}</span>
        </h1>
        <div className="mt-5 inline-block bg-brand-600/90 text-white px-5 py-2 rounded-md text-sm font-medium">
          {slide.tagline}
        </div>

        <div className="mt-8 flex items-center gap-6">
          {slide.features.map((f) => {
            const Icon = ICONS[f.icon] ?? Leaf
            return (
              <div key={f.label} className="flex flex-col items-center text-center">
                <div className="w-14 h-14 rounded-full bg-white shadow-card flex items-center justify-center mb-2">
                  <Icon className={`w-7 h-7 ${f.color}`} />
                </div>
                <div className="text-xs font-medium text-text whitespace-pre-line leading-tight">
                  {f.label}
                </div>
              </div>
            )
          })}
        </div>

        <Link
          to={slide.ctaTo}
          className="mt-8 inline-flex items-center gap-2 bg-brand-600 hover:bg-brand-700 text-white font-semibold px-8 py-3.5 rounded-full shadow-hover transition"
        >
          {slide.ctaLabel}
          <ChevronRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  )
}
